module.exports = __webpack_public_path__ + "static/secondpageimage-c279de3a0854f0740aa561cff95523d2.png";